export const button_trigger_color = [
  { value: "primary", text: "Primary (blue)" },
  { value: "secondary", text: "Secondary (dark grey)" },
  { value: "success", text: "Success (green)" },
  { value: "danger", text: "Danger (red)" },
  { value: "warning", text: "Warning (orange)" },
  { value: "info", text: "Info (teal)" },
  { value: "light", text: "Light (light grey)" },
  { value: "dark", text: "Dark (black)" },

  { value: "outline-primary", text: "Outline Primary (blue)" },
  { value: "outline-secondary", text: "Outline Secondary (dark grey)" },
  { value: "outline-success", text: "Outline Success (green)" },
  { value: "outline-danger", text: "Outline Danger (red)" },
  { value: "outline-warning", text: "Outline Warning (orange)" },
  { value: "outline-info", text: "Outline Info (teal)" },
  { value: "outline-light", text: "Outline Light (light grey)" },
  { value: "outline-dark", text: "Outline Dark (black)" },
];
